import { StatusBadge } from '../components/StatusBadge';

// The public landing page. Iteration 01 shipped the static content; iteration 02
// adds the StatusBadge, which reports the live `GET /api/healthz` result.
// White background, single accent colour, clean type (frontend design §7.7,
// NFR-ARCH-01).
export function LandingPage() {
  return (
    <main
      data-testid="landing-page"
      className="flex min-h-full flex-col items-center justify-center bg-white px-6 py-16 text-center"
    >
      <img
        src="/logo.svg"
        alt="Questaurant logo"
        width={72}
        height={72}
        className="mb-6"
      />
      <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-5xl">
        Questaurant
      </h1>
      <p className="mt-4 max-w-md text-base text-gray-600 sm:text-lg">
        Turn dining out into a shared quest. Discover restaurants, build quests
        with friends, and review every visit.
      </p>
      <a
        href="https://questaurant.com.au"
        className="mt-8 inline-flex min-h-[44px] items-center rounded-full bg-accent px-6 py-3 text-base font-semibold text-accent-fg transition hover:opacity-90"
      >
        Coming soon
      </a>
      <div className="mt-10">
        <StatusBadge />
      </div>
      <footer className="mt-16 text-sm text-gray-400">
        &copy; {new Date().getFullYear()} Questaurant
      </footer>
    </main>
  );
}
